import './FormSection.scss';

import { Card, Divider } from 'antd';
import { ReactNode } from 'react';

/**
 * Wrapper genérico de sección de formulario con título y Card de Ant Design.
 *
 * metadata:
 * - feature: forms.section-wrapper
 * - purpose: reemplaza el patrón repetido <Card className="XxxFormSection"><div className="XxxFormTitle">{title}</div>...</Card>
 *   presente en ShipmentForm, ReceptionForm y ServiceOrderForm
 */
interface FormSectionProps {
  title?: string;
  className?: string;
  children: ReactNode;
}

export const FormSection = ({ title, className, children }: FormSectionProps) => (
  <Card className={`FormSection ${className || ''}`}>
    {title && <div className="FormSectionTitle">{title}</div>}
    {children}
  </Card>
);

interface ShowSubsectionProps {
  title: ReactNode;
  orientation?: 'left' | 'center';
  style?: React.CSSProperties;
  children: ReactNode;
}

/**
 * Estandarización de subsecciones dentro de ShowSection para evitar repetir Divider + título.
 * @param props.title Título de la subsección.
 * @param props.children Contenido de la subsección.
 * @returns
 */

export const FormSubsection = (props: ShowSubsectionProps) => {
  const { title, orientation = 'center', style, children } = props;

  return (
    <div className="FormSubsection">
      <Divider
        className={`FormSubsectionTitle FormSubsectionTitle`}
        orientation={orientation}
        plain
        size="small"
        style={style}>
        {title}
      </Divider>
      {children}
    </div>
  );
};
